import axios from "axios";
import store from "redux/Store";
import { v4 as uuidv4 } from "uuid";
import { CLEAR_DOWNLOAD_LIST, OriginTypes, pagingTotalRelation } from "redux/Types";
import DiscreteConfig from "../../modules/ml-music-search/track/DiscreteConfig";
import { SortTypes } from "../../util/table-view/TableTypes";

var reduxModule = "/mlAiTracks/library/";
var trackModule = "/mlTracks/library/";


var searchTransId = null;

export const actionTypes = {
  LOADING: "LOADING" + reduxModule,
  LOAD: "LOAD" + reduxModule,
  CLEAR: "CLEAR" + reduxModule,
  ERROR: "ERROR" + reduxModule,
  FOCUS_ITEM: "FOCUS_ITEM" + reduxModule,
  SELECT_ITEMS: "SELECT_ITEMS" + reduxModule,
  QUERY: "QUERY" + reduxModule,
  RESULT_VIEW: "RESULT_VIEW" + reduxModule,
  ADV_SEARCH: "ADV_SEARCH" + reduxModule,
  POSTING: "POSTING" + reduxModule,
  POST_OK: "POSTOK" + reduxModule,
  POST_ERROR: "POST_ERROR" + reduxModule,
  SET_MESSAGE: "SET_MESSAGE" + reduxModule,
  CLEAR_MESSAGE: "CLEAR_MESSAGE" + reduxModule,
  LOAD_QUERY: "LOAD_QUERY" + reduxModule,
  EDIT_ENABLE: "EDIT_ENABLE" + reduxModule,
  EDIT_ITEM: "EDIT_ITEM" + reduxModule,
  EMPTY_ITEM: "EMPTY_ITEM" + reduxModule,
  UPDATING: "UPDATING" + reduxModule,
  UPDATE_OK: "UPDATE_OK" + reduxModule,
  GETTING_UPDATE_DATA: "GETTING_UPDATE_DATA" + reduxModule,
  UPDATE_DATA_OK: "UPDATE_DATA_OK" + reduxModule,

  POST_UPDATE: "POST_UPDATE" + reduxModule,
  SWITCH_DISCRETE: "SWITCH_DISCRETE" + reduxModule,
  
  SHOW_CTAG_RULE: "SHOW_CTAG_RULE" + trackModule,
  GET_CTAG_RULE: "GET_CTAG_RULE" + trackModule,
  RETRIEVING_CTAG_RULE: "RETRIEVING_CTAG_RULE" + trackModule,
  EMPTY_CTAG_RULE: "EMPTY_CTAG_RULE" + trackModule,

  LOAD_HISTORY: "LOAD_HISTORY" + trackModule,
  REMOVE_HISTORY: "REMOVE_HISTORY" + trackModule,
  REMOVE_HISTORY_ALL: "REMOVE_HISTORY_ALL" + trackModule,
};

const groupBy = (tracks, keys, isEnabled) => {
  if (
    !isEnabled ||
    !keys ||
    keys.length < 1 ||
    !DiscreteConfig ||
    DiscreteConfig.length < 1
  ) {
    tracks.forEach((r, i) => {
      r.orderIndex = i;
      r.discretedTracks = undefined;
      r.discretedKeys = {};
      r.isDiscreteMaster = true;
    });
    return tracks;
  }

  let groupedTracks = tracks.reduce((grouped, track, index) => {
    track.orderIndex = index;
    track.discretedTracks = undefined;
    track.discretedKeys = {};
    track.isDiscreteMaster = true;
    for (let key of keys) {
      const config = DiscreteConfig[key];
      if (config && config.fields && config.fields.length > 0) {
        let keyValues = config.fields.map((k) => {
          let keyVal = track[k];
          if (Array.isArray(keyVal)) {
            keyVal = keyVal.filter((f) => f && f.trim()).join("|");
          }
          return keyVal ? String(keyVal)?.toLowerCase()?.trim() : null;
        });

        if (keyValues.every((r) => r)) {
          track.discretedKeys[config.id] = keyValues.filter((f) => f).join("|");
          if (track.discretedKeys[config.id]) {
            let groupedParant = grouped.find(
              (g) =>
                g.discretedKeys[config.id] === track.discretedKeys[config.id] &&
                (!g.discretedTracks ||
                  g.discretedTracks.every(
                    (h) => h.orderIndex !== track.orderIndex
                  ))
            );
            if (groupedParant) {
              if (groupedParant.discretedTracks) {
                groupedParant.discretedTracks.push(track);
                track.isDiscreteMaster = false;
              } else {
                groupedParant.discretedTracks = [track];
                track.isDiscreteMaster = false;
              }
            }
          }
        }
      }
    }
    if (track.isDiscreteMaster) {
      grouped.push(track);
    }
    return grouped;
  }, []);

  return Object.values(groupedTracks).sort((a, b) =>
    a.orderIndex > b.orderIndex ? 1 : -1
  );
};

export const editItem = (item) => (dispatch) => {
  dispatch({
    type: actionTypes.EDIT_ITEM,
    payload: item,
  });
};

export const RemoveTrack = (message, item, done = null) => (dispatch) => {
  dispatch({
    type: actionTypes.POSTING,
    payload: message,
  });

  const {
    user: {
      credentials: { orgID },
    },
  } = store.getState();
  item.orgId = orgID;
  const tId = uuidv4();

  axios
    .post(`${orgID}/uploads/tracks/removeTrack`, item, {
      headers: { tid: tId, orgid: orgID },
    })
    .then((res) => {
      dispatch({
        type: actionTypes.POST_OK,
        payload: res.data,
      });

      if (done) done(res.data, null);
    })
    .catch((err) => {
      dispatch({
        type: actionTypes.POST_ERROR,
        payload: { e: err },
      });

      if (done) done(null, err);
    });
};

export const updateTrack = (message, item, done = null) => (dispatch) => {
  const {
    user: {
      credentials: { orgID },
    },
  } = store.getState();
  const tId = uuidv4();
  dispatch({
    type: actionTypes.UPDATING,
    payload: message,
  });

  axios
    .post(`${orgID}/tracks/updateTrack`, item)
    .then((res) => {
      dispatch({
        type: actionTypes.POST_OK,
      });

      if (done) done(res.data, null);
    })
    .catch((err) => {
      dispatch({
        type: actionTypes.POST_ERROR,
        payload: { e: err },
      });

      if (done) done(null, err);
    });
};

export const removeExplicitRule = (message, item, done = null) => (dispatch) => {
  const {
    user: {
      credentials: { orgID },
    },
  } = store.getState();
  const tId = uuidv4();
  dispatch({
    type: actionTypes.UPDATING,
    payload: message,
  });

  axios
    .post(`${orgID}/mladmin/ctags/removeExplicitRule`, item)
    .then((res) => {
      dispatch({
        type: actionTypes.POST_OK,
      });

      if (done) done(res.data, null);
    })
    .catch((err) => {
      dispatch({
        type: actionTypes.POST_ERROR,
        payload: { e: err },
      });

      if (done) done(null, err);
    });
};

export const contentAlert = (message, item, done = null) => (dispatch) => {
  const {
    user: {
      credentials: { orgID },
    },
  } = store.getState();
  const tId = uuidv4();
  dispatch({
    type: actionTypes.UPDATING,
    payload: message,
  });

  axios
    .post(`${orgID}/track/contentAlert`, item)
    .then((res) => {
      dispatch({
        type: actionTypes.POST_OK,
      });

      if (done) done(res.data, null);
    })
    .catch((err) => {
      dispatch({
        type: actionTypes.POST_ERROR,
        payload: { e: err },
      });

      if (done) done(null, err);
    });
};

export const setResultView = (view) => (dispatch) => {
  dispatch({
    type: actionTypes.RESULT_VIEW,
    payload: view,
  });
};

export const loadQuery = (query) => (dispatch) => {
  dispatch({
    type: actionTypes.LOAD_QUERY,
    payload: query,
  });
};

export const setAdvSearch = (advsearch) => (dispatch) => {
  dispatch({
    type: actionTypes.ADV_SEARCH,
    payload: advsearch,
  });
};

export const setQuery = (query, done = null) => (dispatch) => {
  dispatch({
    type: actionTypes.QUERY,
    payload: query,
  });

  if (done) done();
};

export const showMessage = (message) => (dispatch) => {
  if (message) {
    dispatch({
      type: actionTypes.SET_MESSAGE,
      payload: message,
    });
  } else {
    dispatch({
      type: actionTypes.CLEAR_MESSAGE,
    });
  }
};

export const clear = () => (dispatch) => {
  dispatch({
    type: actionTypes.CLEAR,
  });
};

export const selectItems = (items) => (dispatch) => {
  dispatch({
    type: actionTypes.SELECT_ITEMS,
    payload: items,
  });
};

export const focusItem = (item) => (dispatch) => {
  dispatch({
    type: actionTypes.FOCUS_ITEM,
    payload: item,
  });

  // Get Rule List of CTAGS
  const {
    mlAiTrackLibrary: { selectedItem, ctagRuleList },
    user: {
      credentials: { orgID },
    },
  } = store.getState();
  if (
    selectedItem &&
    selectedItem.cTagList &&
    selectedItem.cTagList.length > 0
  ) {
    var cTagIds = [];
    selectedItem.cTagList.forEach((item) => {
      cTagIds.push(item.ctagId);
    });
    dispatch({
      type: actionTypes.RETRIEVING_CTAG_RULE,
    });

    axios
      .post(`${orgID}/mladmin/ctags/getCtagRules`, {
        trackId: selectedItem.id,
        cTagIds: cTagIds,
      })
      .then((res) => {
        dispatch({
          type: actionTypes.GET_CTAG_RULE,
          payload: res.data,
          tagtype: selectedItem.cTagList,
        });
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.POST_ERROR,
          payload: { e: err },
        });
      });
  } else {
    dispatch({
      type: actionTypes.GET_CTAG_RULE,
      payload: [],
      tagtype: null,
    });
  }
};

export const discrete = (discreteFlags) => (dispatch) => {
  const {
    mlAiTrackLibrary: { discreteEnabled, originalItems, totalItems, totalRelation },
  } = store.getState();
  let groupedData = groupBy(originalItems, discreteFlags, discreteEnabled);
  dispatch({
    type: actionTypes.LOAD,
    payload: {
      total: totalItems,
      items: groupedData,
      originalItems: originalItems,
      totalRelation: totalRelation
    },
  });
};

export const showAutoMessage = (message) => (dispatch) => {
  dispatch({
    type: actionTypes.POSTING,
    payload: message,
  });
  setTimeout(() => {
    dispatch({
      type: actionTypes.POST_OK,
    });
  }, 3000);
};

const ISO_DATE_RE = /^\d{4}-\d{2}-\d{2}([T ]\d{2}:\d{2}(:\d{2}(\.\d+)?)?(Z|[+-]\d{2}:?\d{2})?)?$/;

const getComparableValue = (item, field) => {
  const value = item?.[field];
  if (Array.isArray(value)) {
    return value.join("|").toLowerCase();
  }
  if (value === null || value === undefined) {
    return "";
  }
  if (typeof value === "number") {
    return value;
  }
  if (typeof value === "boolean") {
    return value ? 1 : 0;
  }
  const asString = String(value);
  if (ISO_DATE_RE.test(asString.trim())) {
    const asDate = Date.parse(asString);
    if (!Number.isNaN(asDate)) {
      return asDate;
    }
  }
  return asString.toLowerCase();
};

const sortResultsLocally = (query, items) => {
  if (!Array.isArray(items) || items.length < 2) return items;
  if (!query?.orderBy) return items;

  const order = query?.order === SortTypes.desc ? SortTypes.desc : SortTypes.asc;
  const direction = order === SortTypes.desc ? -1 : 1;
  const sorted = [...items];

  sorted.sort((a, b) => {
    let left = getComparableValue(a, query.orderBy);
    let right = getComparableValue(b, query.orderBy);

    // When the two values are of different types, compare them as strings.
    if (typeof left !== typeof right) {
      left = String(left).toLowerCase();
      right = String(right).toLowerCase();
    }

    if (left < right) return -1 * direction;
    if (left > right) return 1 * direction;
    return 0;
  });

  return sorted;
};

export const search = ( query ) => (dispatch) => {
  const {
    user: {
      credentials: { orgID },
    },
    mlAiTrackLibrary: {
      discreteEnabled,
      query: { discreteFlags },
      originalItems,
    },
  } = store.getState();


  searchTransId = uuidv4();

  dispatch({
    type: actionTypes.QUERY,
    payload: query,
  });

  if (query && query.orderBy && originalItems?.length) {
    const localItems = sortResultsLocally(query, originalItems);
    const groupedData = groupBy(localItems, discreteFlags, discreteEnabled);
    dispatch({
      type: actionTypes.LOAD,
      payload: {
        total: localItems.length,
        items: groupedData,
        originalItems: originalItems,
        postUpdating: false,
        totalRelation: pagingTotalRelation.EQUALS,
      },
    });
    return;
  }

  if ( query || (query && query.q) ) {

    const options = {
      headers: {
        tid: searchTransId,
      },
    };
    dispatch({
      type: actionTypes.LOADING,
    });

    dispatch({ type: CLEAR_DOWNLOAD_LIST });


    axios
      .post(
        `${orgID}/aims/search/byprompt`,
        query,
        options
      )
      .then((res) => {
        if (res.data.tid === searchTransId) {
          if (res.data?.data.length > 0) {
            axios
              .post(
                `${orgID}/ctag/CheckExplicitCtag`,
                {
                  trackIdList: res.data.data.map((t) => t.id),
                },
                options
              )
              .then((post) => {
                if (post.data.tid === searchTransId) {
                  for (var item of res.data.data) {
                    let trackId = item.id;
                    item.cTagList = post.data.data.find(
                      (opt) => opt.trackId === trackId
                    )?.cTagList;
                  }
                  const { mlAiTrackLibrary: { items, originalItems },  } = store.getState();

                  dispatch({
                    type: actionTypes.POST_UPDATE,
                    payload: {
                      items: items,
                      originalItems: originalItems,
                    },
                  });
                }
              })
              .catch((error) => {
                const {
                  mlAiTrackLibrary: { items, originalItems },
                } = store.getState();
                dispatch({
                  type: actionTypes.POST_UPDATE,
                  payload: {
                    items: items,
                    originalItems: originalItems,
                  },
                });
              });
            let groupedData = groupBy(
              res.data.data,
              discreteFlags,
              discreteEnabled
            );

            dispatch({
              type: actionTypes.LOAD,
              payload: {
                total: res.data.total,
                items: groupedData,
                originalItems: res.data.data,
                postUpdating: true,
                totalRelation: res.data.totalRelation || pagingTotalRelation.EQUALS
              },
            });
            dispatch({
              type: actionTypes.QUERY,
              payload: {
                ...query,
                searchId: res.data.searchId,
              },
            });
          } else {
            dispatch({
              type: actionTypes.LOAD,
              payload: {
                total: 0,
                items: [],
                originalItems: [],
                postUpdating: false,
                totalRelation: pagingTotalRelation.EQUALS
              },
            });
            dispatch({
              type: actionTypes.QUERY,
              payload: { 
                ...query, 
                searchId: res.data.searchId,
               },
            });
          }
        }
      })
      .catch((err) => {
        const errorMessage = (err.response?.data?.details?.code === 4000) 
        ? `Tracks not found in AIMS. Please try again with different prompt.`
        : (err.response?.data?.message || err.message || "Error in searching. please retry");
        if (errorMessage) {
          dispatch(showMessage(errorMessage));
          setTimeout(() => {
            dispatch({
              type: actionTypes.CLEAR_MESSAGE,
            });
          }, 3000);
        }

        dispatch({
          type: actionTypes.ERROR,
          payload: { e: err },
        });
      });
  } else {
    dispatch({
      type: actionTypes.CLEAR,
      payload: [],
    });
  }
};

export const removeTrackSearchkHistory = (trackId) => (dispatch) => {
  dispatch({
    type: actionTypes.REMOVE_HISTORY,
    payload: {
      trackId: trackId
    },
  });
};

export const removeTrackSearchkHistoryAll = () => (dispatch) => {
  dispatch({
    type: actionTypes.REMOVE_HISTORY_ALL,
    payload: {},
  });
};

export const getTrackHistory = (trackId, done = null) => (dispatch) => {
  //   if (done) done({}, null);
  // }
  const {
    user: {
      credentials: { orgID },
    },
  } = store.getState();
  const tId = uuidv4();

  // dispatch({
  //   type: actionTypes.POSTING,
  //   payload: message,
  // });

  axios
    .post(`/libraryTrackHistory`, { trackId: trackId }, {
      headers: { tid: tId, orgid: orgID },
    })
    .then((res) => {
      //if (res.data.tid === tId) {
      dispatch({
        type: actionTypes.LOAD_HISTORY,
        payload: {
          trackId: trackId,
          history: res.data
        }
      });

      if (done) done(res.data, null);
      //}
    })
    .catch((err) => {
      // dispatch({
      //   type: actionTypes.POST_ERROR,
      //   // payload: { e: err },
      //   payload: err.response?.data || { e: (err.message ? err.message : "Error in creating or updating. please retry") },
      // });

      // if (done) done(null, err.response?.data?.name == 'Duplicate Name'?err.response?.data?.name:err.message || "error");
    });
};

export const getTracks = (query, needCtags = true) =>
  new Promise((resolve, reject) => {
    const {
      user: {
        credentials: { orgID },
      },
    } = store.getState();

    if (
      query ||
      (query && query.q) ||
      (query && query.origin !== OriginTypes.all) ||
      (query && query.filters && query.filters.length > 0) ||
      (query && query.all && query.all.q) ||
      (query && query.tagAll && query.All.q)
    ) {
      const options = {
        headers: {},
      };

      axios.post("/librarysearch", query, options).then((res) => {
        if (res.data?.data.length > 0) {
          if (!needCtags) {
            resolve(res?.data?.data ? res.data.data : []);
          } else {
            axios
              .post(
                `${orgID}/ctag/CheckExplicitCtag`,
                {
                  trackIdList: res.data.data.map((t) => t.id),
                },
                options
              )
              .then((post) => {
                for (var item of res.data.data) {
                  let trackId = item.id;
                  item.cTagList = post.data.data.find(
                    (opt) => opt.trackId === trackId
                  )?.cTagList;
                }
                resolve(res?.data?.data ? res.data.data : []);
              })
              .catch((error) => {
                resolve([]);
              });
          }
        } else {
          resolve([]);
        }
      });
    }
  });

export const prsWorkSearch = (message, prsData, done = null) => (dispatch) => {
  const {
    user: {
      credentials: { orgID },
    },
  } = store.getState();

  searchTransId = uuidv4();

  const options = {
    headers: {
      tid: searchTransId,
    },
  };
  dispatch({
    type: actionTypes.POSTING,
    payload: message
  });

  axios
    .post(
      "/prsworksearch",
      prsData,
      options
    )
    .then((res) => {
      if (done) {
        done(res.data, null);
        dispatch({
          type: actionTypes.POST_OK,
        });
      }
    })
    .catch((err) => {
      if (done) {
        done(null, err);
      }
    });

};

export const postItem = (action, message, items, id, type, done = null) => (
  dispatch
) => {
  if (id != null) {
    items = [];
    items.push(id);
  }

  let payload = {};
  payload.type = type;
  payload.ids = items;

  const {
    user: {
      credentials: { orgID },
    },
    mlAiTrackLibrary: { query },
  } = store.getState();

  const tId = uuidv4();

  dispatch({
    type: actionTypes.POSTING,
    payload: message,
  });

  //TODO : change the endpoint after backend implementation.
  axios
    .post(`${orgID}/contentadmin/Workspace/${action}`, payload, {
      headers: { tid: tId, orgid: orgID },
    })
    .then((res) => {
      dispatch({
        type: actionTypes.POST_OK,
        payload: items,
      });

      search(query)(dispatch);

      if (done) done(res.data, null);
    })
    .catch((err) => {
      dispatch({
        type: actionTypes.POST_ERROR,
        payload: err,
      });

      if (done) done(null, err);
    });
};

export const copyTrack = (message, item, done = null) => (dispatch) => {
  const {
    user: {
      credentials: { orgID },
    },
  } = store.getState();
  const tId = uuidv4();
  item.orgId = orgID;
  dispatch({
    type: actionTypes.POSTING,
    payload: message,
  });

  axios
    .post(`${orgID}/contentadmin/copyTrack`, item, {
      headers: { tid: tId, orgid: orgID },
    })
    .then((res) => {
      dispatch({
        type: actionTypes.POST_OK,
        payload: res.data,
      });

      if (done) done(res.data, null);
    })
    .catch((err) => {
      dispatch({
        type: actionTypes.POST_ERROR,
        payload: { e: err },
      });
    });
};